import React, { useEffect, useState } from 'react'
import { Box, Grid, Collapse, useMediaQuery, IconButton, Theme } from '@mui/material'
import ReactPlayer from 'react-player/lazy'
import HtmlReactParser from 'html-react-parser'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import Slider, { Settings } from 'react-slick'
import { img } from '../../imgs'
import { Modal } from '../../components'
import { useReduxSelector } from '../../hooks'

const NextArrow = (props: any) => {
  const { className, style, onClick, md, count } = props

  return (
    <Box className={className} style={{ ...style }}>
      <IconButton color="primary" disabled={count} onClick={onClick}>
        <ArrowForwardIosIcon style={{ fontSize: md ? 30 : 45 }} />
      </IconButton>
    </Box>
  )
}

const PrevArrow = (props: any) => {
  const { className, style, onClick, md, count } = props

  return (
    <Box className={className} style={{ ...style }}>
      <IconButton color="primary" disabled={count} onClick={onClick}>
        <ArrowBackIosNewIcon style={{ fontSize: md ? 30 : 45 }} />
      </IconButton>
    </Box>
  )
}

export const NewsVideoModal: React.FC<{
  item: any
  indexSlide?: number
  listPhoto?: any
  show: boolean
  onClose: () => any
  className: any
}> = ({ item = [], indexSlide = 0, listPhoto = [], className, show = false, onClose = () => {} }): JSX.Element => {
  const { REACT_APP_DEBUG: DEBUG } = process.env

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))
  const md = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))

  const { data: constants } = useReduxSelector((state) => state.constants)

  const settings: Settings = {
    dots: false,
    speed: 300,
    infinite: true,
    easing: 'cubic',
    slidesToScroll: 1,
    initialSlide: indexSlide,
    slidesToShow: 1,
    afterChange(index: number) {},
    nextArrow: <NextArrow md={md} />,
    prevArrow: <PrevArrow md={md} />,
  }

  const [collapse, setCollapse] = useState<boolean>(true)

  const onCloseModal = () => {
    onClose()
    setCollapse(false)
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  return (
    <Modal maxWidth={sm ? 'sm' : 'md'} open={show} onClose={onCloseModal}>
      <Collapse in={collapse}>
        {item.type === 'INTERVIEW' && item?.typeSrc === 'PHOTO' ? (
          <Box mt={3} className={className.newsBox}>
            <Grid container justifyContent="center">
              <Grid item xs={10}>
                <img
                  src={
                    item.src
                      ? constants?.PROFILE === 'prod'
                        ? `https://cup.irb.rest${item.src}`
                        : `https://irbcup.xtest.atoms.ru${item.src}`
                      : ''
                  }
                  alt=""
                  className={className.imgModal}
                />
              </Grid>
            </Grid>
            {item.type === 'INTERVIEW' && <Box className={className.titleModal}>{item.name}</Box>}
            {item.body && (
              <Box className={className.textModal}>{HtmlReactParser(item.body.replace(/[\r\n]+/g, '<br/>'))}</Box>
            )}
          </Box>
        ) : item.type === 'PHOTO' || item.type === 'REPORTS' ? (
          <Box id="slick" className={className.boxSlider}>
            <Slider {...settings}>
              {listPhoto.map((itemPhoto: any, index: number) => {
                return (
                  <Box className={className.slide}>
                    <Box mt={3} className={className.newsBox}>
                      <Grid container justifyContent="center">
                        <Grid item xs={10}>
                          <Box className={className.imgBoxModal}>
                            <Box>
                              {item?.theme === 'GALA' && (
                                <img src={itemPhoto.src} alt="" className={className.imgModal} />
                              )}
                              {!item?.theme && (
                                <img
                                  src={
                                    itemPhoto.src
                                      ? constants?.PROFILE === 'prod'
                                        ? `https://cup.irb.rest${itemPhoto.src}`
                                        : `https://irbcup.xtest.atoms.ru${itemPhoto.src}`
                                      : ''
                                  }
                                  alt=""
                                  className={className.imgModal}
                                />
                              )}
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid container justifyContent="center">
                        <Grid item xs={10}>
                          <Box className={className.textPhotoModal}>{itemPhoto.name}</Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                )
              })}
            </Slider>
          </Box>
        ) : (
          <>
            <Box className={className.newsVideoBox}>
              <Box className={className.newsVideoBgImg}>
                {/* <ReactPlayer */}
                {/*  playing */}
                {/*  controls */}
                {/*  width="100%" */}
                {/*  height="100%" */}
                {/*  volume={0.5} */}
                {/*  url={[ */}
                {/*    { */}
                {/*      src: item.srcVideo[0].src, */}
                {/*      type: item.srcVideo[0].type, */}
                {/*    }, */}
                {/*    { */}
                {/*      src: item.srcVideo[1].src, */}
                {/*      type: item.srcVideo[1].type, */}
                {/*    }, */}
                {/*  ]} */}
                {/*  config={{ */}
                {/*    file: { */}
                {/*      attributes: { */}
                {/*        controlsList: 'noplaybackrate nodownload', */}
                {/*        disablepictureinpicture: 'true', */}
                {/*      }, */}
                {/*    }, */}
                {/*  }} */}
                {/* /> */}
                <video autoPlay controls width="100%" crossOrigin={DEBUG ? undefined : 'anonymous'}>
                  {item.srcVideo.map((k: any, i: number) => (
                    <source key={`source-${i}`} src={`${k.src}`} type={`${k.type}`} />
                  ))}
                </video>
              </Box>
            </Box>
            <Box className={className.newsVideoText}>{item?.name}</Box>
          </>
        )}
      </Collapse>
    </Modal>
  )
}
